import { ISlackQuery } from '../interfaces/slack.query.interface';

export class FetchModuleSlackSuccess {
    static readonly type = '[Module] FetchModuleSlackSuccess';

    constructor(public payload: ISlackQuery) {}
}
